import { calcSpacing } from 'src/components/foundations';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const DescriptionCard = styled.aside`
  cursor: default;
  width: 480px;
  min-width: 400px;
  max-width: 480px;
  max-height: 600px;
  box-sizing: border-box;
  border-radius: 12px;
  padding: ${calcSpacing(3)}px 0;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  box-shadow: ${(props) => props.theme.boxShadows.shadowLarge};
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 1000;

  @media (max-width: 520px) {
    width: calc(100vw - 48px);
    min-width: 0;
  }
`;

export const DescriptionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${calcSpacing(1.6)}px;
  padding: 0 ${calcSpacing(2.4)}px;
`;

export const DescriptionTitle = styled.h2`
  margin: 0;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH2)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const DescriptionCloseButton = styled.button`
  width: 32px;
  height: 32px;
  border: 0;
  padding: 0;
  background: transparent;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &:focus-visible {
    outline: 2px solid
      ${(props) => props.theme.atlas.semantic.color.ui.focusRing};
    outline-offset: 2px;
  }
`;

export const DescriptionContent = styled.div`
  padding: ${calcSpacing(2.8)}px ${calcSpacing(2.4)}px ${calcSpacing(2.4)}px;
  display: flex;
  flex-direction: column;
  gap: ${calcSpacing(1.6)}px;
  overflow-y: auto;
  max-height: 500px;

  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};

  .ql-editor {
    padding: 0;
  }

  p {
    margin: 0 0 16px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    margin: 0 0 16px 0;
    padding-left: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  li {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
